import {Injectable, NgZone, signal} from '@angular/core';
import {MOBILE_QUERY} from 'app/common/mobile/mobile-view.directives';

/**
 * Whether the viewport is a phone (below 600px), for the few places where the mobile layer needs
 * behaviour rather than styling: not driving a DHTMLX timeline that is hidden, disabling cdkDrag so a
 * scroll does not start a drag, opening a popover's template as a bottom sheet, navigating in the same
 * tab instead of window.open.
 *
 * Everything that CSS can do stays in src/styles/_mobile-*.scss. Reach for this only when it cannot.
 *
 * Same breakpoint as the stylesheets and the mobile directives, so the TypeScript and the CSS always
 * agree on what a phone is.
 */
@Injectable({providedIn: 'root'})
export class MobileViewportService {
    private readonly _isPhone = signal(false);

    /** True below 600px. Updates when the viewport crosses the breakpoint (rotation, resize). */
    readonly isPhone = this._isPhone.asReadonly();

    constructor(zone: NgZone) {
        if (typeof window === 'undefined' || !window.matchMedia) {
            return;
        }
        const media = window.matchMedia(MOBILE_QUERY);
        this._isPhone.set(media.matches);
        // Root service, so it lives as long as the app and the listener never needs removing.
        media.addEventListener('change', (event) => zone.run(() => this._isPhone.set(event.matches)));
    }
}
